import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useInfiniteQuery } from 'react-query';
import { QueryKey } from '../../domain/enums/query-keys.js';
import { GetComments } from '../../usecases/get-comments.js';

const useGetComments = ({
  postId,
  pageSize,
  orderDir
}) => {
  const container = useContainer();
  return useInfiniteQuery([QueryKey.getComments, postId, orderDir], ({
    pageParam: _pageParam = 1
  }) => new GetComments(container.get(HttpClient)).execute({
    postId,
    page: _pageParam,
    pageSize,
    orderDir
  }), {
    refetchOnWindowFocus: false,
    getNextPageParam: oldData => {
      var _a, _b;
      const nextPage = ((_a = oldData === null || oldData === void 0 ? void 0 : oldData.page) !== null && _a !== void 0 ? _a : 0) + 1;
      const lastPage = (_b = oldData === null || oldData === void 0 ? void 0 : oldData.lastPage) !== null && _b !== void 0 ? _b : 0;
      if (nextPage > lastPage) {
        return undefined;
      }
      return nextPage;
    }
  });
};

export { useGetComments };
